import axios from "../../../config/axios";
import { BASE_URL_API } from "../../../config/env";
import {useMutation} from 'react-query'


export const useVineyardAddImageToGallery = () => {
    return useMutation((data) => {
        return axios.post(`${BASE_URL_API}/api/v1/admin/vineyard/add-gallery-image`, data).then(({data}) => data)
    })
}